<template>
    <div>
        <div class="schedules-title">{{ $t('configuration_management.schedules.title') }}</div>
        <div class="schedules-top">
            <schedules-search></schedules-search>
        </div>
        <table-schedules></table-schedules>
    </div>
</template>

<script>
    import SchedulesSearch from '../schedules/SchedulesSearch'
    import TableSchedules from '../schedules/TableSchedules'

    export default {
        name: 'Schedules',
        components: { 
            SchedulesSearch,
            TableSchedules 
        }
    }
</script>

<style scoped>
    .schedules-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .schedules-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/schedules/Schedules.vue